export default "__VITE_ASSET__WXCHSKaG__"